import useIsCompatibilityPathway from 'hooks/use-is-compatibility-pathway';
import { ComparisonSystemPick } from './comparison-system-pick';
import DuctedSystemListPanel from './ducted-system-list-panel';
import { SwapListModel } from './swap-list-model';
import SystemListPanel from './system-list-panel';

export type ComparisonSystemPickerProps = Readonly<{
  swapListModel: SwapListModel;
  comparedIdByCardId: ReadonlyMap<string, string>;
  selectedId: string | null;
  disabledIds: ReadonlySet<string>;
  onPick: (pick: ComparisonSystemPick) => void;
}>;

export default function ComparisonSystemPicker({
  swapListModel,
  comparedIdByCardId,
  selectedId,
  disabledIds,
  onPick
}: ComparisonSystemPickerProps) {
  const isDucted = useIsCompatibilityPathway();

  if (isDucted) {
    return (
      <DuctedSystemListPanel
        comparedIdByCardId={comparedIdByCardId}
        selectedId={selectedId}
        disabledIds={disabledIds}
        onSelect={(selection) => onPick({ kind: 'ducted', selection })}
        onAddBundle={(slots) => onPick({ kind: 'bundle', slots })}
      />
    );
  }

  return (
    <SystemListPanel
      model={swapListModel}
      selectedId={selectedId}
      disabledIds={disabledIds}
      onSelect={(system) => onPick({ kind: 'system', system })}
    />
  );
}
